<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card :title="title" color="primary">
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
          class="white--text mt-n4"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" class="body-2" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-n2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessContact",

  props: {
    dark: Boolean,
    dense: Boolean,
    title: String
  },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "Jl. Persada Raya No. 70 C-D, Menteng Dalam, Tebet, Jakarta 12870"
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text:
          'Telp: <a class="white--text" href="tel:02128543111">(021) 285 43111</a> (Hunting)<br>Fax: (021) 285 43222'
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: `<div style="line-height:1.2;">
                  <h3 style="margin:0; font-weight:bold;">Sekretaris Perusahaan</h3>
                  <a class="white--text" style="font-size:15px;" href="mailto:company@takafulumum.co.id">
                    company@takafulumum.co.id
                  </a>
                </div>
                <br>
                <div style="line-height:1.2;">
                  <h3 style="margin:0; font-weight:bold;">Layanan Konsumen</h3>
                  <a class="white--text" style="font-size:15px;" href="mailto:cs@takafulumum.co.id">
                    cs@takafulumum.co.id
                  </a>
                </div>`
      }
    ]
  })
};
</script>
